import { bl_fi_comp_workflow_gendoc_process_template_hdr_RowClass, bl_fi_comp_workflow_gendoc_process_template_hdr_RowInterface} from "../../dbschema";
import { BaseContainerModel } from "../base-container.model";

export class CompanyWorkflowGendocProcessContainerModel extends BaseContainerModel{
  bl_fi_comp_workflow_gendoc_process_template_hdr: bl_fi_comp_workflow_gendoc_process_template_hdr_RowInterface = new bl_fi_comp_workflow_gendoc_process_template_hdr_RowClass();
}
